import React from 'react';
import './pagetemplate.css';
import Header from '../../organisms/Headers/Header';
import Footer from '../../organisms/Footer/Footer';

// interface TemplateProps {
//   children: React.ReactNode;
// }

// const PageTemplate: React.FC<TemplateProps> = ({ children }) => {
//   return (
//     <div className="container">
//       <main>{children}</main>
//     </div>
//   );
// };

// export default PageTemplate;
interface TemplateProps {
  children: React.ReactNode;
}

const PageTemplate: React.FC<TemplateProps> = ({ children }) => {
  return (
    <div>
      <Header></Header>
      {children}
      <Footer text='Alvero Software Solutions LLC'></Footer>
    </div>
  );
};

export default PageTemplate;